import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function LayoutCenter({ children }: Props) {
  return (
    <div className="flex flex-col min-h-screen w-full items-center justify-center px-4 py-8">
      {children}
    </div>
  );
}
